import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { JOB_REQUEST_STATUSES } from './jobRequestStatus.js';

interface DashboardCounts {
  readonly total?: number;
  readonly byStatus?: Record<string, number>;
}

export function SalesDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [kpis, setKpis] = useState<DashboardCounts | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<DashboardCounts>('/v1/job-requests/dashboard', { token })
      .then((r) => { if (alive) setKpis(r ?? {}); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <main><p role="alert">{error}</p></main>;
  if (!kpis) return <main><p>{t('sales.dash.loading')}</p></main>;

  return (
    <main aria-label="sales-dashboard">
      <h1>{t('sales.dash.title')}</h1>
      <ul aria-label="kpi-list">
        <li aria-label="kpi-total">{t('sales.dash.total')}: {kpis.total ?? 0}</li>
        {JOB_REQUEST_STATUSES.map((s) => (
          <li key={s} aria-label={`kpi-${s}`}>{t(`sales.dash.status.${s}`)}: {kpis.byStatus?.[s] ?? 0}</li>
        ))}
      </ul>
    </main>
  );
}
